<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="findPopupPagingInfo.pageUnit"
		:totalSize="findPopupPagingInfo.totalSize"
		paging
		index
		:columns="columns"
		:stripe="false"
		:rows="rows"
		height="55vh"
		:excel="isButton_(scrId, 'EX')"
		@changedPage="changedPage"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'partNo'">
				<span class="highlighted" @click="() => rowClick(slotProps.row)">{{ slotProps.row.partNo }}</span>
			</template>
		</template>
	</sf-data-table>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.findPopupResultList;
		},
		columns() {
			return this.getPopColumns_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		rowClick(params) {
			this.$emit('SelectRow', params);
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setFindPopupPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setFindPopupPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	}
};
</script>
